import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.563 4.75h3.39c.328 0 .684.164.93.41l1.832 1.832c.246.246.41.602.41.93v6.016c0 .738-.602 1.312-1.312 1.312h-5.25a1.296 1.296 0 0 1-1.313-1.312V6.062c0-.71.574-1.312 1.313-1.312m-4.376 3.5h2.188V10h-1.75v7h5.25v-.875h1.75v1.313c0 .738-.602 1.312-1.312 1.312H7.187a1.296 1.296 0 0 1-1.312-1.312V9.563c0-.711.574-1.313 1.313-1.313"
    }, null, -1)
  ]))]))
}
export default { render: render }